module.exports = __webpack_public_path__ + "img/9788952757234.cacb73a7.jpg";